import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash'; // import cx from 'classnames'

import i18n from 'i18next';
import { useSelector, useDispatch } from 'react-redux';
import $ from 'jquery';
import { TablePagination } from '@material-ui/core';
import ToggleBtn from 'ui/components/toggle-button';
import PopupDialog from 'ui/components/popup-dialog';
import Tabs from './ui/react-ui/tabs';
import DataTable from './ui/table';
import SearchBar from './ui/searchBar';
import Progress from './ui/react-ui/progress.jsx';
import UserEdit from './userManagemant/user-edit';
import RightsEdit from './userManagemant/rights-edit';
import { getUserList, getUserInfo, getAuthorizations, getRoleRightList, editUserAPI, deleteMultipleUserAPI, deleteMultipleRoleRightAPI } from '../api/userAPI';
import { setUserList, setUserSort, setRoleRightList, setRoleRightSort, setAllRoleRightList, setDialogInfo, setAuthorizations, clearDialogInfo } from '../redux/user-management';
var t = i18n.getFixedT(null, 'user-management');
var gt = i18n.getFixedT(null, 'app');

var UserManagement = function UserManagement(props) {
  // redux
  var _useSelector = useSelector(function (state) {
    return state.toJS();
  }),
      contextRoot = _useSelector.envCfg.contextRoot,
      _useSelector$userMana = _useSelector.userManagement,
      userList = _useSelector$userMana.userList,
      userSort = _useSelector$userMana.userSort,
      roleRightList = _useSelector$userMana.roleRightList,
      roleRightSort = _useSelector$userMana.roleRightSort,
      mode = _useSelector$userMana.dialogInfo.mode;

  var dispatch = useDispatch();
  var id = props.id;

  var _useState = useState('userAccounts'),
      _useState2 = _slicedToArray(_useState, 2),
      currentTab = _useState2[0],
      setCurrentTab = _useState2[1];

  var _useState3 = useState(0),
      _useState4 = _slicedToArray(_useState3, 2),
      totalCount = _useState4[0],
      setTotalCount = _useState4[1];

  var _useState5 = useState(0),
      _useState6 = _slicedToArray(_useState5, 2),
      currentPage = _useState6[0],
      setCurrentPage = _useState6[1];

  var _useState7 = useState(10),
      _useState8 = _slicedToArray(_useState7, 2),
      rowsPerPage = _useState8[0],
      setRowsPerPage = _useState8[1];

  var _useState9 = useState([]),
      _useState10 = _slicedToArray(_useState9, 2),
      selectedItems = _useState10[0],
      setSelectedItems = _useState10[1];

  var _useState11 = useState(''),
      _useState12 = _slicedToArray(_useState11, 2),
      keyword = _useState12[0],
      setKeyword = _useState12[1];

  var _isMounted = useRef(false);

  var _isResetUseState = useRef(false);

  var tabsMenu = [{
    key: 'userAccounts',
    title: t('lbl-user-account')
  }, {
    key: 'userRights',
    title: t('lbl-role-rights')
  }];

  var handleOpenDialog = function handleOpenDialog(mode) {
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (mode !== 'user.edit') return dispatch(setDialogInfo({
      mode: mode,
      data: data
    }));
    getUserInfo(contextRoot, false, data.id).then(function (result) {
      dispatch(setDialogInfo({
        mode: mode,
        data: result.value
      }));
    });
  };

  var handleChangePage = function handleChangePage(e, newPage) {
    setCurrentPage(newPage);
  };

  var handleChangeRowsPerPage = function handleChangeRowsPerPage(e) {
    setRowsPerPage(parseInt(e.target.value, 10));
    setCurrentPage(0);
  };

  var handleToogleStatus = function handleToogleStatus(data) {
    var newData = {
      id: data.id,
      isEnabled: !data.isEnabled
    };
    editUserAPI(contextRoot, false, newData).then(function (result) {
      handleGetData();
    });
  };

  var handleCloseDialogEdit = function handleCloseDialogEdit() {
    dispatch(clearDialogInfo());
    setSelectedItems([]);
    handleGetData();
  };

  var handleSort = function handleSort(sort) {
    if (currentTab === 'userAccounts') dispatch(setUserSort(sort));else dispatch(setRoleRightSort(sort));
  };

  var handleGetData = function handleGetData() {
    var isInit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var _currentPage, _rowsPerPage, _keyword;

    _currentPage = isInit ? 0 : currentPage;
    _rowsPerPage = isInit ? 10 : rowsPerPage;
    _keyword = isInit ? '' : keyword;

    var offset = (Number(_currentPage + 1) - 1) * _rowsPerPage;

    if (currentTab === 'userAccounts') {
      return getUserList(contextRoot, false, _keyword, userSort, offset, _rowsPerPage).then(function (result) {
        var userListData = _.map(result.content, function (el, index) {
          return _objectSpread(_objectSpread({}, el), {}, {
            sequence: offset + index + 1
          });
        });

        dispatch(setUserList(userListData));
        setTotalCount(result.totalElements);
      });
    } else {
      return getRoleRightList(contextRoot, false, _keyword, roleRightSort, offset, _rowsPerPage).then(function (result) {
        var roleRightList = _.map(result.content, function (el, index) {
          return _objectSpread(_objectSpread({}, el), {}, {
            sequence: offset + index + 1
          });
        });

        dispatch(setAllRoleRightList(result.content));
        dispatch(setRoleRightList(roleRightList));
        setTotalCount(result.totalElements);
      });
    }
  };

  var handleDelete = function handleDelete(singleId) {
    var deleteItems = [];
    if (singleId) deleteItems.push(singleId);else _.forEach(selectedItems, function (id) {
      return deleteItems.push(id);
    });
    var filterAry = currentTab === 'userAccounts' ? userList : roleRightList;

    var deleteList = _.filter(filterAry, function (el) {
      return _.some(deleteItems, function (id) {
        return id === el.id;
      });
    });

    var deleteText = _.join(_.map(deleteList, function (el) {
      return currentTab === 'userAccounts' ? el.username : el.name;
    }), ', ');

    var displayText = t("txt-delete-".concat(currentTab === 'userAccounts' ? 'user' : 'right'), {
      user: deleteText
    });
    PopupDialog.confirm({
      title: t("dlg-delete-".concat(currentTab)),
      display: displayText,
      cancelText: gt('global.lbl-answer-cancel'),
      confirmText: gt('global.lbl-answer-ok'),
      act: function act(confirmed) {
        if (confirmed) {
          var deleteAPI;
          Progress.startSpin();
          if (currentTab === 'userAccounts') deleteAPI = deleteMultipleUserAPI(contextRoot, true, deleteItems);else deleteAPI = deleteMultipleRoleRightAPI(contextRoot, true, deleteItems);
          deleteAPI.then(function (result) {
            handleGetData();
            setSelectedItems([]);
          }).catch(function (error) {
            Progress.done();
            PopupDialog.alert({
              display: t(error.message),
              confirmText: gt('global.lbl-answer-ok')
            });
          });
        }
      }
    });
  };

  var handeUserExport = function handeUserExport() {
    $.ajax({
      url: "".concat(contextRoot, "/user/export"),
      method: 'GET',
      beforeSend: function beforeSend(xhr) {
        Progress.startSpin();
      },
      data: {
        offset: 0,
        limit: null,
        sort: 'username:asc',
        keyword: ''
      },
      xhrFields: {
        responseType: 'blob'
      },
      success: function success(data) {
        console.log(data);
        var a = document.createElement('a');
        a.style.display = 'none';
        a.href = window.URL.createObjectURL(data);
        a.setAttribute('download', "accounts-list.xlsx");
        a.click();
        document.body.appendChild(a);
        window.URL.revokeObjectURL(a.href);
        document.body.removeChild(a);
        Progress.done();
      }
    });
  };

  useEffect(function () {
    if (!_isMounted.current) return;
    if (!_isResetUseState.current) handleGetData();
    _isResetUseState.current = false;
  }, [JSON.stringify(userSort), JSON.stringify(roleRightSort), keyword, currentPage, rowsPerPage]);
  useEffect(function () {
    if (!_isMounted.current) return;
    if (currentPage !== 0 || keyword !== '' || rowsPerPage !== 10 || selectedItems.length > 0) _isResetUseState.current = true;
    setCurrentPage(0);
    setKeyword('');
    setRowsPerPage(10);
    setSelectedItems([]);
    handleGetData(true);
  }, [currentTab]);
  useEffect(function () {
    if (!_isMounted.current) {
      _isMounted.current = true;
      Progress.startSpin();
      var offset = (Number(currentPage + 1) - 1) * rowsPerPage;

      var _userList = getUserList(contextRoot, true, keyword, userSort, offset, rowsPerPage);

      var authorizations = getAuthorizations(contextRoot, true);

      var _roleRightList = getRoleRightList(contextRoot, true);

      $.when(_userList, authorizations, _roleRightList).then(function (userListResult, authorizationsResult, roleRightListResult) {
        var userListData = _.map(userListResult.content, function (el, index) {
          return _objectSpread(_objectSpread({}, el), {}, {
            sequence: index + 1
          });
        });

        dispatch(setUserList(userListData));
        dispatch(setAuthorizations(authorizationsResult.content));
        dispatch(setAllRoleRightList(roleRightListResult.content));
        setTotalCount(userListResult.totalElements);
        Progress.done();
      });
    }
  }, []);
  var fields = {};

  _.set(fields, 'sequence', {
    label: t('lbl-sequence')
  });

  if (currentTab === 'userAccounts') {
    _.set(fields, 'username', {
      label: t('lbl-account'),
      sortable: true
    });

    _.set(fields, 'name', {
      label: t('lbl-name'),
      sortable: true
    });

    _.set(fields, 'mobilePhone', {
      label: t('lbl-contact-phone'),
      sortable: true
    });

    _.set(fields, 'email', {
      label: t('lbl-eMail'),
      sortable: true
    });

    _.set(fields, 'unit', {
      label: t('lbl-department'),
      sortable: true
    });

    _.set(fields, 'accountGroupName', {
      label: t('lbl-role-rights'),
      sortable: true
    });

    _.set(fields, 'terminals', {
      label: t('lbl-terminal'),
      formatter: function formatter(val, row) {
        if (row.username === 'admin') return /*#__PURE__*/React.createElement("span", null, t('lbl-all-terminal'));
        var terminalsTextAry = [];

        _.forEach(val, function (el) {
          terminalsTextAry.push(el.name);
        });

        return /*#__PURE__*/React.createElement("span", null, _.join(terminalsTextAry, ' / '));
      }
    });

    _.set(fields, 'isEnabled', {
      label: t('lbl-enable-status'),
      formatter: function formatter(val, row) {
        return /*#__PURE__*/React.createElement(ToggleBtn, {
          id: "alarmSound",
          onChange: function onChange(val) {
            return handleToogleStatus(row);
          },
          on: val,
          disabled: row.username === 'admin'
        });
      }
    });

    _.set(fields, 'more', {
      label: t('lbl-more'),
      formatter: function formatter(val, row) {
        return /*#__PURE__*/React.createElement("div", {
          className: "icon-block"
        }, /*#__PURE__*/React.createElement("a", null, /*#__PURE__*/React.createElement("i", {
          className: "fa fa-pencil-alt fa-list-alt",
          onClick: function onClick() {
            return handleOpenDialog('user.edit', row);
          }
        })), row.username !== 'admin' && /*#__PURE__*/React.createElement("a", {
          className: "delete",
          onClick: function onClick() {
            return handleDelete(row.id);
          }
        }, /*#__PURE__*/React.createElement("i", {
          className: "fa fa-trash"
        })));
      }
    });
  } else {
    _.set(fields, 'name', {
      label: t('lbl-role-name')
    });

    _.set(fields, 'permissions', {
      label: t('lbl-owned-rights'),
      formatter: function formatter(val, row) {
        if (val.length === 0) return null;
        var permissionsTextAry = [];

        _.forEach(val, function (el) {
          permissionsTextAry.push(el.name);
        });

        return /*#__PURE__*/React.createElement("span", null, _.join(permissionsTextAry, ' / '));
      }
    });

    _.set(fields, 'more', {
      label: t('lbl-more'),
      formatter: function formatter(val, row) {
        if (row.name === 'Administrator Group') return null;
        return /*#__PURE__*/React.createElement("div", {
          className: "icon-block"
        }, /*#__PURE__*/React.createElement("a", null, /*#__PURE__*/React.createElement("i", {
          className: "fa fa-pencil-alt fa-list-alt",
          onClick: function onClick() {
            return handleOpenDialog('rights.edit', row);
          }
        })), /*#__PURE__*/React.createElement("a", {
          className: "delete",
          onClick: function onClick() {
            return handleDelete(row.id);
          }
        }, /*#__PURE__*/React.createElement("i", {
          className: "fa fa-trash"
        })));
      }
    });
  }

  return /*#__PURE__*/React.createElement("div", {
    id: id
  }, /*#__PURE__*/React.createElement("div", {
    className: "userManagement-headBar"
  }, /*#__PURE__*/React.createElement(SearchBar, {
    searchIconPosition: "right",
    placeholder: "Search",
    onSearch: function onSearch(search) {
      setKeyword(search); // if(_.isEmpty(search))
      //     handleGetData()
    },
    value: keyword
  }), currentTab === 'userAccounts' ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("a", {
    className: "icon",
    onClick: function onClick() {
      return handleOpenDialog('user.create');
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: "fas fa-user-plus"
  })), /*#__PURE__*/React.createElement("a", {
    className: "icon",
    onClick: function onClick() {
      return handeUserExport();
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: "fa fa-download",
    title: t('lbl-user-export')
  }))) : /*#__PURE__*/React.createElement("a", {
    className: "icon",
    onClick: function onClick() {
      return handleOpenDialog('rights.create');
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: "fas fa-plus"
  }))), /*#__PURE__*/React.createElement(Tabs, {
    id: "g-user-management-tabs",
    menu: tabsMenu,
    current: currentTab,
    onChange: function onChange(key) {
      return setCurrentTab(key);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "c-border c-position-rlt"
  }, /*#__PURE__*/React.createElement(DataTable, {
    rowIdField: "id",
    selectable: {
      toggleAll: true
    },
    selected: selectedItems,
    onSelectionChange: function onSelectionChange(val) {
      return setSelectedItems(val);
    },
    fields: fields,
    data: currentTab === 'userAccounts' ? userList : roleRightList,
    sort: currentTab === 'userAccounts' ? userSort : roleRightSort,
    onSort: handleSort,
    enableIgnoreSelection: true,
    ignoreSelectionObj: {
      type: currentTab === 'userAccounts' ? 'username' : 'name',
      value: [currentTab === 'userAccounts' ? 'admin' : 'Administrator Group']
    }
  })), /*#__PURE__*/React.createElement(TablePagination, {
    component: "div",
    labelRowsPerPage: t('lbl-per-page-row-count'),
    count: totalCount,
    page: currentPage,
    onChangePage: handleChangePage,
    rowsPerPage: rowsPerPage,
    onChangeRowsPerPage: handleChangeRowsPerPage
  }), /*#__PURE__*/React.createElement("div", {
    className: "footer"
  }, /*#__PURE__*/React.createElement("button", {
    className: "button",
    onClick: function onClick() {
      return handleDelete();
    },
    disabled: selectedItems.length > 0 ? false : true
  }, t('lbl-delete')))), /*#__PURE__*/React.createElement(UserEdit, {
    onClose: handleCloseDialogEdit
  }), /*#__PURE__*/React.createElement(RightsEdit, {
    onClose: handleCloseDialogEdit
  }));
};

UserManagement.defaultProps = {
  id: 'g-user-management'
};
UserManagement.PropTypes = {
  id: PropTypes.string
};
export default UserManagement;